module.exports = __webpack_public_path__ + "img/12.83c8bc41.png";